import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSuites(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/suites', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteSuite(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`reservation/suites/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
